import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-video-call-room',
  templateUrl: './video-call-room.component.html',
  styleUrls: ['./video-call-room.component.scss']
})
export class VideoCallRoomComponent implements OnInit {
  isCollapsed = true;
  constructor() { }

  ngOnInit(): void {
  }
  slidechat() {
    document.getElementById("show-user-detail").classList.toggle("open-chat-sidebar");
  }

  closechatside() {
    document.getElementById("show-user-detail").classList.remove("open-chat-sidebar");
  }

  slideuserchat() {
    document.getElementById("show-user-detail").classList.toggle("open-user-sidebar");
  }

  closeuserchatside() {
    document.getElementById("show-user-detail").classList.remove("open-user-sidebar");
  }
}
